const ACTIVE_CLASS = "expandable-panels__block--active";

class ExpandingBlocks extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      accordionItem: ".expandable-panels__block",
      accordionButton: ".expandable-panels__toggle",
      accordionContent: ".expandable-panels__content",
    };

    this.accordionItems = [
      ...this.querySelectorAll(this.selectors.accordionItem),
    ];

    this.init(this.accordionItems);

    if (this.group) {
      document.addEventListener("expandable-panel:opened", (e) => {
        if (e.target === this) return;

        this.closeAllAccordions();
      });
    }
  }

  init(items) {
    items.forEach((item) => {
      const button = item.querySelector(this.selectors.accordionButton);
      button.addEventListener("click", (event) => {
        const item = event.target.closest(this.selectors.accordionItem);

        if (!item.classList.contains(ACTIVE_CLASS)) {
          this.closeAllAccordions(item);
          this.openAccordion(item);
          this.classList.add("expandable-panels--open");
        } else {
          this.closeAccordion(item);
          this.classList.remove("expandable-panels--open");
        }
      });

      if (item.classList.contains(ACTIVE_CLASS)) {
        this.openAccordion(item);
      }
    });
  }

  closeAllAccordions(currentItem) {
    this.accordionItems.forEach((item) => {
      if (currentItem != item) {
        this.closeAccordion(item, false);
      }
    });
  }

  openAccordion(item) {
    if (item.classList.contains(ACTIVE_CLASS)) return;
    this.dispatchEvent(
      new CustomEvent("expandable-panel:opened", { bubbles: true }),
    );

    const button = item.querySelector(this.selectors.accordionButton);
    button.setAttribute("aria-expanded", true);

    const content = item.querySelector(this.selectors.accordionContent);

    content.style.display = null;

    window.requestAnimationFrame(() => {
      content.style.setProperty(
        "--content-height",
        `${content.scrollHeight}px`,
      );
      item.classList.add(ACTIVE_CLASS);
    });
  }

  closeAccordion(item) {
    if (!item.classList.contains(ACTIVE_CLASS)) return;

    const content = item.querySelector(this.selectors.accordionContent);

    item.removeEventListener("transitionend", this.onEnd);

    this.onEnd = (e) => {
      if (e.target != item) return;
      item.removeEventListener("transitionend", this.onEnd);
      content.style.display = "none";

      const button = item.querySelector(this.selectors.accordionButton);
      button.setAttribute("aria-expanded", false);
    };

    item.addEventListener("transitionend", this.onEnd);
    content.style.setProperty("--content-height", `${content.scrollHeight}px`);

    window.requestAnimationFrame(() => {
      item.classList.remove(ACTIVE_CLASS);
    });
  }
}

if (!customElements.get("expandable-panels")) {
  customElements.define("expandable-panels", ExpandingBlocks);
}
